<template>
  <div class="rf-category-pg-wrapper prompts-list--wrapper">
    <div>
      <div class="all-segments-list-rightcol nodata-rightcol">
        <div v-if="sequence" class="rf-detail-content-wrapper retention-detail-container">
          <RfLimitWarning />
          <div class="detail-itempg-title-div">
            <div class="detail-itempg-title-div-left">
              <h3 class="flex items-center gap-2">
                <span>{{ sequence.name }}</span>
                <RfButton
                  icon="md:edit"
                  variant="plain"
                  density="compact"
                  color="accent"
                  iconSize="16"
                  class="ml-1"
                  size="x-small"
                  :tooltip="{ location: 'bottom' }"
                  :disabled="userStore.isDisabledWithMessage"
                  @click="showInfoEditor"
                />
              </h3>
              <span class="detail-itempg-title-desc">{{ sequence.description }}</span>
            </div>
            <div class="inline-flex">
              <RfButton
                v-if="
                  sequence.sequence_type === GUIDE_TYPES.tour.value ||
                  (sequence.sequence_type === GUIDE_TYPES.web_client.value &&
                    (lockedDeviceType === 'web' || lockedDeviceType === null))
                "
                buttonText="Live preview"
                icon="md:open_in_new"
                variant="outlined"
                size="small"
                :disabled="userStore.isDisabledWithMessage"
                :tooltip="{ location: 'bottom' }"
                color="info"
                class="mr-2"
                @click="() => domainChooseDialog?.open()"
              />
              <RfDomainChooserWrapper ref="domainChooseDialog" @open="openLivePreview" />
              <RfButtonNew
                v-if="isAiAgentEnabled"
                size="none"
                class="mr-2 border bg-transparent! px-3 py-0 text-xs!"
                @click="clickLive"
              >
                <RfAgentIcon class="h-4! w-4!" />
                Agent
              </RfButtonNew>

              <RfButton
                buttonText="Clone"
                icon="md:content_copy"
                variant="outlined"
                size="small"
                :disabled="userStore.isDisabledWithMessage"
                :tooltip="{ location: 'bottom' }"
                color="info"
                class="mr-2"
                @click="$refs.cloneModal.show()"
              />
              <RfCloneGuideModal
                ref="cloneModal"
                :sequence="sequence"
                :isSuperAdmin="userStore.isCurrentSuperAdmin"
                :isCompanyAdmin="userStore.isCurrentAdmin"
                :currApp="app"
                :currUser="userStore.currUser"
                @clone="submitClone"
              />
              <v-dialog v-model="showDialog" persistent width="500">
                <template #activator="{ props }">
                  <RfButton
                    v-bind="props"
                    icon="md:clear"
                    buttonText="Delete"
                    variant="outlined"
                    size="small"
                    :disabled="userStore.isDisabledWithMessage"
                    :tooltip="{ location: 'bottom' }"
                    color="error"
                  />
                </template>
                <v-card>
                  <v-card-title class="headline">Are you sure you want to delete?</v-card-title>
                  <v-card-text
                    >Deleting this Guide removes all information about this Guide. This cannot be
                    undone. Deleting a guide will also delete all of its prompts.
                  </v-card-text>
                  <v-card-actions class="modal-card-actions-div">
                    <v-btn
                      class="cancel-btn"
                      variant="outlined"
                      style="width: 100px"
                      @click="showDialog = false"
                      >Cancel</v-btn
                    >
                    <v-btn variant="flat" color="error" style="width: 150px" @click="submitDelete"
                      >Delete</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
          <v-card class="promo-hero-div">
            <div class="seq-view-hero-div">
              <div v-if="sequence" class="promo-hero-col-wrapper seq-detail-info-display">
                <div class="promo-hero-col left-col">
                  <RfPromoDetailsInfoRow title="Show Prompts">
                    <template #promodetail>
                      <div>
                        {{ displaySequenceType }}
                      </div>
                    </template>
                  </RfPromoDetailsInfoRow>
                  <RfPromoSegmentsInfo
                    :path="sequence"
                    :editDisabled="userStore.isDisabledWithMessage"
                  />
                  <RfPromoLimitsInfo
                    :item="sequence"
                    :editDisabled="userStore.isDisabledWithMessage"
                  />
                  <RfPromoDetailsInfoRow
                    v-if="sequence.sequence_type === GUIDE_TYPES.ordered.value"
                    title="Loop"
                  >
                    <template #promodetail>
                      <v-checkbox
                        v-model="loop"
                        label="Loop"
                        hideDetails
                        class="promo-hero-col--loop"
                        density="compact"
                      />
                    </template>
                  </RfPromoDetailsInfoRow>
                  <RfPromoDetailsInfoRow v-if="isWebClient && firstPrompt" title="Triggers">
                    <template #promodetail>
                      Inherited from
                      <router-link :to="firstPromptLink">{{ firstPrompt.name }}</router-link>
                    </template>
                  </RfPromoDetailsInfoRow>
                </div>
                <div class="promo-hero-col right-col-col-1">
                  <RfStateButtons
                    :item="sequence"
                    :editDisabled="userStore.isDisabledWithMessage"
                  />
                  <RfPromoScheduleInfo
                    :item="sequence"
                    :editDisabled="userStore.isDisabledWithMessage"
                    @editCategory="$refs.engagementCategoryModal?.show()"
                  />
                </div>
              </div>
              <div v-if="sequence" class="placement-stats-full-width">
                <div class="chart-filter-date-select">
                  <div class="chart-filter-label">Date range:</div>
                  <RfMetricsDateRangeSelector
                    :key="sequence.id"
                    parentPage="sequences"
                    @fetchMetrics="fetchMetrics"
                    @fetchMetricsCustom="fetchMetricsCustom"
                  />
                </div>
                <RfSingleSequenceStats
                  v-if="
                    [
                      GUIDE_TYPES.web_client.value,
                      GUIDE_TYPES.ordered.value,
                      GUIDE_TYPES.survey.value,
                      GUIDE_TYPES.tour.value,
                    ].includes(sequence?.sequence_type)
                  "
                  :model="sequence.paths"
                  :metricsKey="currChartSrc"
                  :singleDayCustom="singleDayCustom"
                  :isSurvey="sequence.sequence_type === GUIDE_TYPES.survey.value"
                />
                <RfSinglePromoStats
                  v-else
                  :model="sequence.paths"
                  :metricsKey="currChartSrc"
                  :singleDayCustom="singleDayCustom"
                />
              </div>
            </div>
          </v-card>
          <div
            class="border-grey-4 mb-4 flex items-center justify-between border-b border-solid pt-8 pb-4"
          >
            <h2 class="text-lg">Prompts</h2>
            <div v-if="paths.length" class="flex flex-wrap justify-end gap-2">
              <RfButtonNew
                class="shrink-0"
                type="ghost"
                @click="exportMultiplePromptToCsv(paths, currChartSrc)"
              >
                <RfDownloadIcon class="h-6 w-6" />
                Export All to CSV
              </RfButtonNew>
              <RfButtonNew
                class="shrink-0"
                type="secondary"
                :disabled="userStore.isDisabledWithMessage || !paths.length"
                @click="showPathsEditor"
              >
                <RfPriorityIcon class="h-6 w-6" />
                {{ orderCTA }}
              </RfButtonNew>
              <RfButtonNew
                class="shrink-0"
                :disabled="
                  userStore.isDisabledWithMessage ||
                  (isRunning && 'Cannot add items to a running guide')
                "
                @click="showPromoDeviceTypeDialog"
              >
                <RfAddIcon class="h-6 w-6" />
                Add Prompt
              </RfButtonNew>
            </div>
          </div>
          <div v-if="sequence">
            <div v-if="sequence.paths?.length" class="sq-promos-list">
              <div v-if="isTour" class="sq-promos-item-wrapper">
                <div class="sq-promos-item-wrapper-ft">
                  <div class="sq-promos-item--ft-left">
                    <div class="pr-ctnd-cond">
                      <label>
                        <v-icon color="success" start>md:arrow_downward</v-icon>
                        Transition:
                      </label>
                      <div class="seq-promo-restriction gap-2">
                        <span v-if="sequence.paths[0]?.actions?.rf_settings_tour_url">
                          {{ sequence.paths[0]?.actions?.rf_settings_tour_url }}
                        </span>
                        <template v-if="sequence.paths[0]?.actions?.rf_settings_tour_show_js">
                          <v-icon
                            v-if="sequence.paths[0]?.actions?.rf_settings_tour_url"
                            size="14"
                            class="text-grey-4"
                          >
                            md:arrow_forward
                          </v-icon>
                          <span
                            class="bg-blue-1 rounded-full px-2 py-0.5 text-[10px] font-semibold text-blue-50"
                          >
                            SHOW
                          </span>
                        </template>
                      </div>
                      <RfButton
                        icon="md:edit"
                        variant="plain"
                        density="compact"
                        color="accent"
                        iconSize="16"
                        size="x-small"
                        :disabled="userStore.isDisabledWithMessage"
                        class="edit-path-sequence-button"
                        @click="openTourTransition(null, sequence.paths[0])"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-for="(item, index) in sequence.paths"
                :key="item.id"
                :class="itemsListClassName"
              >
                <span v-if="canReorder" class="seq-item-number">{{ index + 1 }}</span>

                <div class="sq-promos-item-wrapper">
                  <div class="sq-promos-item-inner promo-list-view-wrapper">
                    <RfPromotionsListViewItem
                      v-if="getPathObject(item)"
                      :item="getPathObject(item, true)"
                      :currChartSrc="currChartSrc"
                      preprocessedGoals
                      hideSegment
                      hideSchedule
                      hideSequence
                      hideStatus
                      fromSequence
                    />
                  </div>
                  <div class="sq-promos-item-wrapper-ft">
                    <div v-if="isTour" class="sq-promos-item--ft-left">
                      <div class="pr-ctnd-cond">
                        <label>
                          <v-icon color="success" start>md:arrow_downward</v-icon>
                          Transition:
                        </label>
                        <div class="seq-promo-restriction gap-2">
                          <span
                            v-if="item.actions?.rf_settings_tour_hide_js"
                            class="bg-blue-1 rounded-full px-2 py-0.5 text-[10px] font-semibold text-blue-50"
                          >
                            HIDE
                          </span>
                          <template v-if="sequence.paths[index + 1]?.actions?.rf_settings_tour_url">
                            <v-icon
                              v-if="item.actions?.rf_settings_tour_hide_js"
                              size="14"
                              class="text-grey-4"
                            >
                              md:arrow_forward
                            </v-icon>
                            <span>
                              {{ sequence.paths[index + 1].actions.rf_settings_tour_url }}
                            </span>
                          </template>
                          <template
                            v-if="sequence.paths[index + 1]?.actions?.rf_settings_tour_show_js"
                          >
                            <v-icon
                              v-if="
                                item.actions?.rf_settings_tour_hide_js ||
                                sequence.paths[index + 1]?.actions?.rf_settings_tour_url
                              "
                              size="14"
                              class="text-grey-4"
                            >
                              md:arrow_forward
                            </v-icon>
                            <span
                              class="bg-blue-1 rounded-full px-2 py-0.5 text-[10px] font-semibold text-blue-50"
                            >
                              SHOW
                            </span>
                          </template>
                        </div>
                        <RfButton
                          icon="md:edit"
                          variant="plain"
                          density="compact"
                          color="accent"
                          iconSize="16"
                          size="x-small"
                          :disabled="userStore.isDisabledWithMessage"
                          class="edit-path-sequence-button"
                          @click="
                            openTourTransition(
                              item,
                              index < sequence.paths.length - 1 ? sequence.paths[index + 1] : null,
                            )
                          "
                        />
                      </div>
                    </div>
                    <div v-if="!isTour" class="sq-promos-item--ft-left">
                      <div v-if="canContinue(index)" class="pr-ctnd-cond">
                        <label>
                          <v-icon color="success" start>
                            {{
                              index === sequence.paths.length - 1
                                ? "md:refresh"
                                : "md:arrow_downward"
                            }}
                          </v-icon>
                          {{ index === sequence.paths.length - 1 ? "Loops" : "Continues" }}
                          <span class="interval-display">{{ intervalDisplay(item) }}</span> when:
                        </label>
                        <RfSequencePathsDisplayCell
                          :interactionTypes="item.continue_interaction_types"
                          :isContinue="true"
                          :path="getPathObject(item)"
                        />
                        <RfButton
                          icon="md:edit"
                          variant="plain"
                          density="compact"
                          color="accent"
                          iconSize="16"
                          size="x-small"
                          :disabled="userStore.isDisabledWithMessage"
                          class="edit-path-sequence-button"
                          @click="editPath(index)"
                        />
                      </div>
                      <div v-if="isSkippable(item)" class="pr-skip-cond">
                        <label
                          ><v-icon color="#3096ED" start>md:next_plan</v-icon>Skips when:</label
                        >
                        <RfSequencePathsDisplayCell
                          :interactionTypes="item.skip_interaction_types"
                          :path="getPathObject(item)"
                        />
                        <RfButton
                          icon="md:edit"
                          variant="plain"
                          density="compact"
                          color="accent"
                          iconSize="16"
                          size="x-small"
                          :disabled="userStore.isDisabledWithMessage"
                          class="edit-path-sequence-button"
                          @click="editPath(index)"
                        />
                      </div>
                      <div class="pr-exit-cond">
                        <label
                          ><v-icon color="#3096ED" start>md:exit_to_app</v-icon>Exits when:</label
                        >
                        <RfSequencePathsDisplayCell
                          :interactionTypes="item.interaction_types"
                          :path="getPathObject(item)"
                        />
                        <RfButton
                          icon="md:edit"
                          variant="plain"
                          density="compact"
                          color="accent"
                          iconSize="16"
                          size="x-small"
                          :disabled="userStore.isDisabledWithMessage"
                          class="edit-path-sequence-button"
                          @click="editPath(index)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="no-item-placement-view">
                <div class="no-msg">
                  <span class="no-msg-copy">No prompts in this guide</span>
                  <RfButton
                    class="seq-add-items-button"
                    icon="md:add"
                    buttonText="Add Prompt"
                    size="large"
                    :disabled="userStore.isDisabledWithMessage"
                    color="success"
                    @click="showPromoDeviceTypeDialog"
                  />
                </div>
              </div>
            </div>
          </div>
          <RfEditModal ref="editModalRef" title="Guide Name and Description" @confirm="saveInfo" />
          <v-dialog v-model="pathsEditor" maxWidth="900" persistent>
            <v-card>
              <v-card-title>Manage Prompts</v-card-title>
              <v-card-text v-if="pathsEditor">
                <div v-if="canReorder" style="margin-bottom: 16px">
                  <span>Drag and drop to change order</span>
                </div>
                <RfSequencePaths ref="paths" :sequence="sequence" />
              </v-card-text>
              <v-card-actions class="modal-card-actions-div">
                <v-btn
                  size="large"
                  class="cancel-btn"
                  variant="outlined"
                  width="100px"
                  @click="closePathsEditor"
                  >Close</v-btn
                >
                <v-btn size="large" width="200px" color="success" variant="flat" @click="savePaths">
                  <v-icon size="small" start>md:save</v-icon>Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <RfEngagementCategoryModal
            ref="engagementCategoryModal"
            kind="guide"
            :item="sequence"
            @save="saveEngagementCategory"
          />
          <RfTourStepSettings
            v-if="tourTransitionOpen"
            v-model="tourTransitionOpen"
            :prevPath="tourTransitionPrevPath"
            :nextPath="tourTransitionNextPath"
            :appId="appId"
            @saved="sequencesStore.getSequence({ appId, sequenceId })"
          />
          <RfSequenceAddPath
            v-if="addPromoModule"
            ref="conditionEditor"
            v-model:addPromoModule="addPromoModule"
            :sequence="sequence"
            :newPathSequenceId="newPathSequenceId"
            :newPathInteractions="newPathInteractions"
            :newPathContinueInteractions="newPathContinueInteractions"
            :newPathContinueInterval="newPathContinueInterval"
            :newPathSkipInteractions="newPathSkipInteractions"
            :editIndex="editIndex"
            :isEditing="true"
            @hideAddPromoModule="hideAddPromoModule"
            @addPath="addPath"
          />
          <RfCreateNewPrompt
            ref="newPromptDialogRef"
            :sequenceId="sequence.id"
            :sequenceOrder="sequence.paths.length"
            :lockedDeviceType="lockedDeviceType"
            @created="sequencesStore.getSequence({ appId, sequenceId })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RfEditModal from "@/components/modals/RfEditModal.vue";
import RfSequencePaths from "@/components/RfSequences/RfSequencePaths.vue";
import RfSinglePromoStats from "@/components/RfPromotions/RfSinglePromoStats.vue";
import RfSingleSequenceStats from "@/components/RfPromotions/RfSingleSequenceStats.vue";
import RfPromoSegmentsInfo from "@/components/RfPromotions/RfPromoSegmentsInfo.vue";
import RfPromoLimitsInfo from "@/components/RfPromotions/RfPromoLimitsInfo.vue";
import RfPromoScheduleInfo from "@/components/RfPromotions/RfPromoScheduleInfo.vue";
import RfStateButtons from "@/components/RfPromotions/RfStateButtons.vue";
import RfSequencePathsDisplayCell from "@/components/RfSequences/RfSequencePathsDisplayCell.vue";
import RfSequenceAddPath from "@/components/RfSequences/RfSequenceAddPath.vue";
import RfTourStepSettings from "@/components/RfSequences/RfTourStepSettings.vue";
import RfPromoDetailsInfoRow from "@/components/RfPromotions/RfPromoDetailsInfoRow.vue";
import RfCreateNewPrompt from "@/blocks/RfModals/RfCreateNewPrompt.vue";
import PromoTypeMixin from "@/utils/PromoTypeMixin";
import { useUserSettings } from "@/utils/composables/useUserSettings";
import RfLimitWarning from "@/components/RfCommonCards/RfLimitWarning.vue";
import RfPromotionsListViewItem from "@/components/RfPromotions/RfPromotionsListViewItem.vue";
import RfButton from "@/components/buttons/RfButton.vue";
import RfEngagementCategoryModal from "@/blocks/RfModals/RfEngagementCategoryModal.vue";
import { cloneDeep, isEmpty } from "lodash-es";
import RfMetricsDateRangeSelector from "@/components/RfCommonCards/RfMetricsDateRangeSelector.vue";
import { useLive } from "@/utils/composables/useLive";
import RfDomainChooserWrapper from "@/components/RfCommonCards/RfDomainChooserWrapper.vue";
import { GUIDE_TYPES } from "@/utils/constants/GuidesConstants";
import { canReorder, isRunning, getLockedDeviceTypeForSequence } from "@/utils/guideHelpers";
import { tally } from "@/utils/metricsHelpers";
import { useToastsStore } from "@/pinia/toastsStore";
import { exportMultiplePromptToCsv } from "@/utils/CsvUtils";
import { useLegacyLastErrorStore } from "@/pinia/legacyLastErrorStore";
import {
  shouldShowEngagementCategoryNudge,
  clearNudgeDismissal,
} from "@/utils/engagementCategoryNudge";
import { ENGAGEMENT_CATEGORY_DESCRIPTION } from "@/utils/constants/EngagementCategoryConstants";
import RfAgentIcon from "@/components/icons/RfRobotIcon.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import { useSequencesStore } from "@/pinia/sequencesStore";
import { useAppsStore } from "@/pinia/appsStore";
import { useAllPromptsStore } from "@/pinia/allPromptsStore";
import { useUserStore } from "@/pinia/userStore";
import RfCloneGuideModal from "@/blocks/RfModals/RfCloneGuideModal.vue";
import { getGuideLink } from "@/utils/getLink";
import { useDynamicTitle } from "@/utils/composables/useDynamicTitle";
import { useTemplateRef } from "vue";
import RfPriorityIcon from "@/components/icons/RfPriorityIcon.vue";
import RfAddIcon from "@/components/icons/RfAddIcon.vue";
import RfDownloadIcon from "@/components/icons/RfDownloadIcon.vue";

export default {
  name: "RfSequenceView",
  components: {
    RfEditModal,
    RfSequencePaths,
    RfMetricsDateRangeSelector,
    RfSinglePromoStats,
    RfPromoSegmentsInfo,
    RfPromoLimitsInfo,
    RfPromoScheduleInfo,
    RfStateButtons,
    RfSequencePathsDisplayCell,
    RfSequenceAddPath,
    RfTourStepSettings,
    RfPromoDetailsInfoRow,
    RfCreateNewPrompt,
    RfLimitWarning,
    RfPromotionsListViewItem,
    RfButton,
    RfDomainChooserWrapper,
    RfSingleSequenceStats,
    RfButtonNew,
    RfAgentIcon,
    RfCloneGuideModal,
    RfEngagementCategoryModal,
    RfPriorityIcon,
    RfAddIcon,
    RfDownloadIcon,
  },
  mixins: [PromoTypeMixin],
  setup: () => {
    const { getUserSetting, setUserSetting } = useUserSettings();
    return {
      toastsStore: useToastsStore(),
      GUIDE_TYPES,
      ENGAGEMENT_CATEGORY_DESCRIPTION,
      exportMultiplePromptToCsv,
      sequencesStore: useSequencesStore(),
      appsStore: useAppsStore(),
      allPromptsStore: useAllPromptsStore(),
      userStore: useUserStore(),
      legacyLastErrorStore: useLegacyLastErrorStore(),
      live: useLive(),
      domainChooseDialog: useTemplateRef("domainChooseDialog"),
      getUserSetting,
      setUserSetting,
    };
  },
  data() {
    return {
      showDialog: false,
      singleDayCustom: false,
      pathsEditor: false,
      paths: [],
      directSave: true,
      sequence: null,
      currChartSrc: null,
      sequenceListKey: 0,
      newSequence: {
        name: "",
        description: "",
        paths: [],
        segments: [],
      },
      newSequencePaths: [],
      isAiAgent: false,
      addPromoModule: false,
      tourTransitionOpen: false,
      tourTransitionPrevPath: null,
      tourTransitionNextPath: null,
      newPathInteractions: [],
      newPathContinueInteractions: [],
      newPathSkipInteractions: [],
      newPathSequenceId: null,
      editIndex: -1,
      newPathContinueInterval: 0,
    };
  },
  computed: {
    lastError() {
      return this.legacyLastErrorStore.lastError;
    },
    app() {
      return this.appsStore.app;
    },
    currSequence() {
      return this.sequencesStore.currSequence;
    },
    isAiAgentEnabled() {
      return (
        this.app.flags.ai_agent_guide_id &&
        !!this.app.flags.ai_agent_guide_id.length &&
        this.app.flags.ai_agent_guide_id === this.sequenceId
      );
    },
    loop: {
      get() {
        return !!this.sequence?.filter?.loop;
      },
      set(value) {
        const model = cloneDeep(this.sequence);
        model.filter.loop = value;
        this.saveSequence(model);
      },
    },
    itemsListClassName() {
      return this.canReorder ? "sq-promos-list-item" : "sq-promos-list-item unordered--list";
    },
    orderCTA() {
      return this.canReorder ? "Order/Delete" : "Delete Prompts";
    },
    appId() {
      return this.$route.params.aid;
    },
    sequenceId() {
      return this.$route.params.sid;
    },
    sequenceType() {
      return this.sequence?.sequence_type;
    },
    isRunning() {
      return isRunning(this.sequence);
    },
    canReorder() {
      return canReorder(this.sequence);
    },
    isWebClient() {
      return this.sequenceType === GUIDE_TYPES.web_client.value;
    },
    lockedDeviceType() {
      return getLockedDeviceTypeForSequence(this.sequence ?? {});
    },
    isTour() {
      return this.sequenceType === GUIDE_TYPES.tour.value;
    },
    displaySequenceType() {
      return GUIDE_TYPES[this.sequenceType]?.label || GUIDE_TYPES.survey.label;
    },
    firstPrompt() {
      return this.currSequence?.paths?.[0];
    },
    firstPromptLink() {
      if (!this.firstPrompt) return {};
      return {
        path: `/apps/${this.$route.params.aid}/experiences/${this.currSequence.id}/promotions/${this.firstPrompt.id}`,
      };
    },
    engagementCategories() {
      return this.app?.engagement_categories || [];
    },
  },
  watch: {
    async $route(to) {
      const appId = to.params.aid;
      const sequenceId = to.params.sid;
      if (sequenceId === undefined) {
        this.sequence = null;
        this.sequenceListKey++;
      } else {
        this.sequencesStore.getSequence({ appId, sequenceId });
      }
    },
    currSequence(to) {
      if (!to) return;
      if (this.cloning) {
        this.$router.replace({
          path: `/apps/${this.$route.params.aid}/experiences/${to.id}`,
        });
        this.cloning = false;
      } else {
        this.sequence = to;
        if (to.paths) this.paths = to.paths;

        // Check if we should show engagement category nudge modal on page load
        this.$nextTick(() => {
          if (shouldShowEngagementCategoryNudge(this.app, to, "guide")) {
            this.$refs.engagementCategoryModal?.show();
          }
        });
      }
    },
    async lastError(to) {
      if (!to) return;
      if (to.cause === 404) {
        this.$router.push({ path: `/apps/${this.appId}/experiences` });
      } else {
        this.toastsStore.create({ type: "error", body: to.message });
      }
    },
  },
  mounted() {
    useDynamicTitle(() => this.sequence?.name && `${this.sequence.name} | Guides`);

    this.executeMount();
  },
  methods: {
    hideAddPromoModule() {
      this.addPromoModule = false;
      this.newPathInteractions = [];
      this.newPathContinueInteractions = [];
      this.newPathSkipInteractions = [];
      this.newPathContinueInterval = 0;
      this.newPathSequenceId = null;
      this.editIndex = -1;
    },
    openAddPromoMenu() {
      this.addPromoModule = true;
    },
    openTourTransition(prevPath, nextPath) {
      this.tourTransitionPrevPath = prevPath;
      this.tourTransitionNextPath = nextPath;
      this.tourTransitionOpen = true;
    },
    addPath(newPath) {
      if (this.editIndex >= 0) {
        this.paths[this.editIndex] = { ...this.paths[this.editIndex], ...newPath };
      } else {
        this.paths.push(newPath);
      }
      this.hideAddPromoModule();
      if (this.directSave) {
        this.saveConditions();
      }
    },
    editPath(index) {
      this.newPathSequenceId = this.paths[index].id;
      this.newPathInteractions = this.paths[index].interaction_types;
      this.newPathContinueInteractions = this.paths[index].continue_interaction_types;
      this.newPathSkipInteractions = this.paths[index].skip_interaction_types;
      this.newPathContinueInterval = this.paths[index].continue_interval_minutes;
      this.editIndex = index;
      this.openAddPromoMenu();
    },
    clickLive() {
      this.domainChooseDialog?.open();
      this.isAiAgent = true;
    },
    async fetchMetrics(timePeriod, force) {
      this.singleDayCustom = false;
      const metric_periods = [{ period: timePeriod }];
      if (
        force ||
        !this.sequence ||
        !this.sequence.paths.find(
          retention => retention.data.impressions && retention.data.impressions[timePeriod],
        )
      ) {
        await this.sequencesStore.getSequence({
          appId: this.appsStore.app.id,
          sequenceId: this.sequenceId,
          params: {
            metric_periods,
          },
        });
      }
      this.currChartSrc = timePeriod;
    },
    fetchMetricsCustom(timePeriod) {
      this.singleDayCustom = timePeriod[0] === timePeriod[1];
      this.sequencesStore.getSequence({
        appId: this.appsStore.app.id,
        sequenceId: this.sequenceId,
        params: {
          metric_periods: [{ period: "custom", date_range: timePeriod }],
        },
      });
      this.currChartSrc = "custom";
    },
    submitDelete() {
      this.sequencesStore
        .deleteSequence({ appId: this.appId, sequenceId: this.sequenceId })
        .then(() => {
          this.$router.replace({ path: `/apps/${this.appId}/experiences` });
          this.showDialog = false;
        })
        .catch(() => null);
    },
    showInfoEditor() {
      this.$refs.editModalRef?.open({
        name: this.sequence.name,
        description: this.sequence.description,
      });
    },
    showPathsEditor() {
      this.pathsEditor = true;
    },
    closePathsEditor() {
      this.pathsEditor = false;
    },
    async savePaths() {
      const model = cloneDeep(this.sequence);
      this.$refs.paths.fillModel(model);
      await this.saveSequence(model);
      this.closePathsEditor();
    },
    async saveInfo({ name, description }) {
      const model = { ...cloneDeep(this.sequence), name, description };
      await this.saveSequence(model);
    },
async saveEngagementCategory(category, engagementSubcategory) {
      const model = cloneDeep(this.sequence);
      model.engagement_category = category;
      model.engagement_subcategory = engagementSubcategory || null;

      await this.saveSequence(model);

      // Clear nudge dismissal since category was successfully set
      clearNudgeDismissal("guide", this.sequence.id);
    },
    saveConditions() {
      const model = cloneDeep(this.sequence);
      model.paths = cloneDeep(this.paths);
      this.saveSequence(model);
    },
    async saveSequence(model) {
      await this.sequencesStore
        .updateSequence({
          appId: this.appId,
          sequenceId: this.sequence.id,
          modelSequence: model,
        })
        .then(() =>
          this.toastsStore.create({ type: "success", body: "Guide updated successfully" }),
        )
        .catch(() => null);
    },
    getPathObject(item, sumGoals) {
      if (!sumGoals || !item.custom_filter) return item;

      if (Object.keys(item.custom_filter).length > 0) {
        item.data.totalGoals = tally(item.data, this.currChartSrc, "custom_goals_seen");
      } else {
        item.data.totalGoals = tally(item.data, this.currChartSrc, "goals");
      }

      return item;
    },
    async showPromoDeviceTypeDialog() {
      this.$refs.newPromptDialogRef.open();
    },

    async executeMount() {
      const { sequenceId } = this;

      const path = `/apps/${this.appId}/experiences/${sequenceId}`;
      const pathAgent = `/apps/${this.appId}/agent/${sequenceId}`;
      if ([path, pathAgent].includes(this.$route.path))
        return this.sequencesStore.getSequence({ appId: this.appId, sequenceId });

      return this.$router.replace({ path: `/apps/${this.appId}/experiences/${sequenceId}` });
    },
    intervalDisplay(item) {
      let interval = item.continue_interval_minutes;
      if (interval === "VISIT") {
        return "on next visit";
      }
      interval = parseInt(interval);
      if (!interval) return "immediately";

      let unit = "minutes";
      let number = interval;
      if (interval % 1440 === 0) {
        unit = "days";
        number = interval / 1440;
      } else if (interval % 60 === 0) {
        unit = "hours";
        number = interval / 60;
      }
      return `after ${number} ${unit}`;
    },
    canContinue(index) {
      if (this.canReorder && index < this.sequence.paths.length - 1) return true;
      if (this.loop) return true;
    },
    openLivePreview(domain) {
      if (this.isAiAgent) {
        this.live.openLiveUrl(null, domain, {
          mode: 4,
          ai_agent_guide_id: this.app.flags.ai_agent_guide_id,
        });
      } else {
        this.live.viewPreview(domain, { sequenceId: this.sequence.id });
      }
      this.domainChooseDialog?.close();
      this.isAiAgent = false;
    },
    async submitClone({ targetAppId, targetAppName, defaultCompany, engagementCategory = null }) {
      this.cloning = true;
      let body = `Cloned ${this.currSequence.name}`;
      let timeout;

      try {
        const sequence = await this.sequencesStore.cloneSequence({
          appId: this.appId,
          sequenceId: this.sequenceId,
          targetAppId,
          defaultCompany,
          engagementCategory,
        });

        if (this.appsStore.app.id === targetAppId) {
          if (sequence?.id) {
            const link = getGuideLink(sequence.id, this.appsStore.app.id);
            this.$router.push(link);
          }
        } else {
          body += ` to ${targetAppName}`;
          timeout = 5000;
        }
        this.toastsStore.create({ type: "success", body, timeout });
      } catch (error) {
        this.toastsStore.create({ type: "error", body: error.message });
      }
      this.$refs.cloneModal.close();
    },
    isSkippable(item) {
      return !!this.sequence?.filter?.loop && !isEmpty(item?.custom_filter);
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.promo-hero-col--loop) {
  padding-top: 0px !important;
  margin-top: 0px !important;
  .v-label {
    color: #000;
    font-size: 14px;
  }
}
</style>
